<template>
  <v-col :cols="cols" class="text-truncate">
    <v-btn
      text
      block
      tile
      :disabled="disabled"
      :height="height"
      :class="large ? 'px-1 text-h5' : 'px-1 text-body-1'"
      @click="clicked"
    >
      <v-icon v-if="icon" v-text="icon" />
      <span v-else v-text="label" />
    </v-btn>
  </v-col>
</template>

<script>
  import Lockable from '@/Mixins/Lockable'

  export default {
    mixins: [
      Lockable,
    ],

    props: {
      cols: {
        required: true,
        type: [String, Number],
      },
      height: {
        required: true,
        type: [String, Number],
      },
      label: {
        required: false,
        type: [String, Number],
      },
      icon: {
        required: false,
        type: String,
      },
      large: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    computed: {
      disabled () {
        return this.$store.state.orders.dialogs.locked
      },
    },

    methods: {
      clicked (ev) {
        if (this.locked) {
          return
        }
        this.lock()
        this.$emit('clicked', this.label ?? ev)
      },
    },
  }
</script>
